import type { HexTileMap } from '../model/types';
import { generateHexMap } from './generateHexMap';
import { createPerlinIslandsNoise } from './noise/perlinIslands';
import { createSingleLargeIslandPreset } from './presets/perlinIslands';
import { createCircularHexMapShape } from './shapes/circular';

/**
 * A match's map: one large island filling a circular map of `radius`, made
 * from `seed` (settings.ts `resolveMatch` gives both). The same inputs give
 * the same tiles on every peer.
 */
function generateIslandMap(radius: number, seed: string): HexTileMap {
  return generateHexMap({
    shape: createCircularHexMapShape(radius),
    noise: createPerlinIslandsNoise(createSingleLargeIslandPreset(radius)),
    seed,
  }).tiles;
}

export { generateIslandMap };
